import React from "react";
import FullWidthTabs from './tab'

export default function ButtonLogReg() {
  return (
   <div className=' ms-auto'>
   <button className="navbar-top bg-transparent border-0" data-bs-toggle="modal" data-bs-target="#exampleModal">Daftar | Log In</button>
   <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered mb-5">
         <div className="modal-content logReg pb-5 mb-5">
            <div className="modal-header border-0">
               <button type="button" className="btn-close me-4 mt-2" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body mb-0 mb-md-3">
               <div className=" row p-0 m">
                  <div className=" col border-end">
                     <FullWidthTabs />
                  </div>
                  <div className=" col">
                     <div className="">
                        <img alt="" src="/img/largeLogo.png" className="largeLogo ms-auto me-auto d-block mb-4" />
                        <p className="descLogo">Tempat Belanja Fashion No. 1 di Indonesia</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
  );
}
